import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const ColumnBox = styled.div`
    box-sizing: border-box; 
    padding: 0;
    outline: none; 
    & * {
        margin-left:0;
    }
    ${media.desktop`
        padding-right: ${ds.get('metrics.l')};
        padding-left: 0;
    `};
`;

export default ColumnBox;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ThreeColumnGrid/ColumnBox.jsx